import { render, staticRenderFns } from "./Bread.vue?vue&type=template&id=347a9082&scoped=true&"
import script from "./Bread.vue?vue&type=script&lang=js&"
export * from "./Bread.vue?vue&type=script&lang=js&"
import style0 from "./Bread.vue?vue&type=style&index=0&id=347a9082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!//node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347a9082",
  null
  
)

export default component.exports